import { useNavigate } from 'react-router-dom';
import BackNextButtons from 'components/BackNextButtons';
import Compliance from 'components/forms/Compliance';
import JobInfo from 'components/forms/JobInfo';
import { reportEventList } from 'utils/gtag';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

const Job: React.FC<ProgressFormProps> = ({ onSubmit }) => {
    const navigate = useNavigate();

    const submit = ev => {
        ev.preventDefault();

        onSubmit(() => {
            reportEventList('job');

            navigate('../invest');
        });
    };

    return (
        <form noValidate className="open-job-root" onSubmit={submit}>
            <JobInfo />
            <Compliance />
            <BackNextButtons />
        </form>
    );
};

export default withProgressForm({ step: 2, id: 'job', ensure: 'baseinfo', basePath: 'esop' })(Job);
